import React, { useState, memo } from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import styled from "styled-components";
import { MODAL_STYLES } from "../../constants";
import "./Renderables.css";

const ModalHeader = styled.div`
  background: #d97706;
  color: white;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 1em;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.4em;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }
`;

const ModalBody = styled.div`
  padding: 16px 20px 20px;
  max-height: 400px;
  overflow-y: auto;
`;

const WarningCard = styled.div`
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-left: 4px solid #d97706;
  border-radius: 6px;
  padding: 14px 16px;
  margin-bottom: 10px;
  font-size: 0.9em;
  font-weight: 600;
  color: #78350f;
  line-height: 1.5;
  word-break: break-word;

  &:last-child {
    margin-bottom: 0;
  }
`;

const FooterBar = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
`;

const CloseBtn = styled.button`
  background: white;
  color: #555;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 20px;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f3f4f6;
    border-color: #999;
    color: #333;
  }
`;

export const RenderWarningEditable = memo(({ value, column }) => {
  const { id } = column;
  const [showWarningModal, setShowWarningModal] = useState(false);
  const warningText = value.length > 1 ? "Warnings" : "Warning";

  if (value.length === 0) {
    return null;
  }
  return (
    <>
      <ReactModal
        isOpen={showWarningModal}
        style={{
          ...MODAL_STYLES,
          content: { ...MODAL_STYLES.content, maxWidth: "560px" },
        }}
        onRequestClose={() => setShowWarningModal(false)}
        appElement={document.getElementById("root")}
      >
        <ModalHeader>
          Block {warningText}
          <CloseButton onClick={() => setShowWarningModal(false)}>&times;</CloseButton>
        </ModalHeader>
        <ModalBody>
          {value.map((message) => (
            <WarningCard key={`${id}-${message}`}>
              {message}
            </WarningCard>
          ))}
        </ModalBody>
        <FooterBar>
          <CloseBtn onClick={() => setShowWarningModal(false)}>Close</CloseBtn>
        </FooterBar>
      </ReactModal>
      <button
        type="button"
        title={`${value.length} ${warningText}`}
        className="warning-label warning-label-button"
        onClick={() => setShowWarningModal(true)}
      >
        {value.length}
      </button>
    </>
  );
});

RenderWarningEditable.displayName = "RenderWarningEditable";

RenderWarningEditable.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};
